import { GroupSubject, GroupType } from '@schooly/api';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export type WithGroupTypeAndSubject = {
  group_type?: GroupType;
  subject?: Pick<GroupSubject, 'id' | 'name'> | null;
};

export const useRenderGroupType = () => {
  const { formatMessage } = useIntl();

  const renderGroupType = useCallback(
    (group?: WithGroupTypeAndSubject) => {
      if (!group?.group_type) return;

      switch (group.group_type) {
        case GroupType.Subject:
          return group.subject?.name;
        case GroupType.NoSubject:
          return formatMessage({ id: 'groups-NoSubject' });
        case GroupType.TutorGroup:
          return formatMessage({ id: 'groups-TutorGroup' });
        default: {
          const _: never = group.group_type;
          return _;
        }
      }
    },
    [formatMessage],
  );

  return renderGroupType;
};
